export enum BREAKPOINTS {
  MOBILE = 768,
  TABLET = 1024
}
